//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    tableData: {
      default: () => []
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      search: {
        bid: undefined,
        cid: undefined,
        q: undefined,
        status: undefined
      },
      q:'',
      table: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      brandOptions: [],
      categoryOptions: []
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  methods: {
    handleLoadTableData () {
      this.loading = true
      let tableData = []
      let p1 = () => {
        return new Promise((resolve, reject) => {
          let data = _.extend({}, _.pick(this.initialForm, 'dealerId'))
          this.$axios.get('/mtea/store/admin/dealer/goods', {params: data}).then(res => {
            tableData = res
          }).finally(() => {
            resolve()
          })
        })
      }
      let p2 = () => {
        return new Promise((resolve, reject) => {
          let data = _.extend({}, this.search, _.pick(this.page, 'pageNo', 'pageSize'))
          if(this.q!=='')data.q = this.q
          this.$axios.get('/mtea/store/admin/goods/list', {params: data}).then(res => {
            // console.log('res', res)
            _.each(res.records, (t, i, l) => {
              let f = _.findWhere(tableData, { goodsId: t.goodsId })
              if (f) {
                t.costPrice = f.costPrice
              }
              t.selected = f ? 1 : 0
            })
            this.page.total = res.total
            this.table = res.records
          }).finally(() => {
            resolve()
          })
        })
      }

      p1().then(() => {
        p2().then(() => {
          this.loading = false
        })
      })
    },
    handleSubmit (row) {
      this.$emit('submit', row)
      this.$emit('update:visible', false)
    },
    handleOpen () {
      this.handleLoadTableData()
    },
    handleClose () {
      this.$emit('submit')
    }
  }
}
